import BN from "bn.js";
import { arenaInventory, distanceInventory, surfaceInventory, weatherInventory } from '../inventories';
import { QueueModel } from "./queue.model";


export class ArenaModel {
  id: number;
  chain_id: number;
  owner: string;
  token_id: string;
  name: string;
  fee: string;
  currency: string;
  token_uri: string;
  surface: number;
  distance: number;
  weather: number;
  createdAt: Date;
  updatedAt: Date;
  description: string;
  arenaIndex: string;
  queues: QueueModel[];


  constructor(arena: Partial<ArenaModel> = {}) {
    this.name = arena.name;
    this.fee = arena.fee;
    this.token_id = arena.token_id;
    this.chain_id = arena.chain_id;
    this.token_uri = arena.token_uri;
    this.surface = arena.surface;
    this.distance = arena.distance;
    this.weather = arena.weather;
    this.owner = arena.owner;
    this.createdAt = arena.createdAt;
    this.updatedAt = arena.updatedAt;
    this.id = arena.id;
    this.description = arena.description;
    this.arenaIndex = arena.arenaIndex;
    this.queues = arena.queues;
    this.currency = arena.currency;
  }

  arenaType() {
    return arenaInventory.find(arena => arena.value === this.arenaIndex);
  }

  surfaceType() {
    return surfaceInventory[Number(this.surface)];
  }

  distanceType() {
    return distanceInventory[Number(this.distance)];
  }

  weatherType() {
    return weatherInventory[Number(this.weather)];
  }

}